<template>
  <svg
    :class="customStyle"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.92815 3.21177H7.71387C7.83173 3.21177 7.92815 3.11535 7.92815 2.99749V3.21177H16.071V2.99749C16.071 3.11535 16.1674 3.21177 16.2853 3.21177H16.071V5.14035H17.9996V2.99749C17.9996 2.05195 17.2308 1.2832 16.2853 1.2832H7.71387C6.76833 1.2832 5.99958 2.05195 5.99958 2.99749V5.14035H7.92815V3.21177ZM21.4282 5.14035H2.57101C2.0969 5.14035 1.71387 5.52338 1.71387 5.99749V6.85463C1.71387 6.97249 1.8103 7.06892 1.92815 7.06892H3.54601L4.20762 21.0778C4.25048 21.9912 5.00583 22.7118 5.91923 22.7118H18.0799C18.996 22.7118 19.7487 21.9939 19.7916 21.0778L20.4532 7.06892H22.071C22.1889 7.06892 22.2853 6.97249 22.2853 6.85463V5.99749C22.2853 5.52338 21.9023 5.14035 21.4282 5.14035ZM17.8737 20.7832H6.12548L5.47726 7.06892H18.5219L17.8737 20.7832Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'TrashGreenIcon',
  props: {
    customStyle: {
      type: String,
      default: 'size-4 text-theme-header-primary',
    },
  },
}
</script>
